import React from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { DisplayBox } from "../components";
import { ApiHelper } from "../helpers";
import { AdminAccounts, AdminTickets } from "./components";
import { AdminUserSearch } from "./components/AdminUserSearch";
import { AffiliateSettings } from "./components/AffiliateSettings";
import { AffiliateSummary } from "./components/AffiliateSummary";


interface Props {

}


export const AdminPage: React.FC<Props> = props => {

  const [revenue, setRevenue] = React.useState<{ monthlyRevenue: number, commissions: number, netRevenue: number }>({ monthlyRevenue: 0, netRevenue: 0, commissions: 0 });
  const [affiliateAccount, setAffiliateAccount] = React.useState(0);

  const init = () => {
    ApiHelper.get("/billableItems/adminRevenue").then(data => { setRevenue(data); });
  }

  React.useEffect(init, [])

  const getAffiliateSettings = () => {
    if (affiliateAccount > 0) {
      return (<AffiliateSettings affiliateId={affiliateAccount} onDone={() => { setAffiliateAccount(0) }} />)

    }
  }

  const formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

  return (
    <>
      <h1><i className="fas fa-lock"></i> Admin</h1>
      <Row>
        <Col md={7}>
          <Tabs defaultActiveKey="accounts">
            <Tab eventKey="accounts" title="Accounts">
              <AdminAccounts showAffiliate={(accountId: number) => { setAffiliateAccount(accountId); }} />
            </Tab>
            <Tab eventKey="users" title="Users">
              <AdminUserSearch />
            </Tab>
          </Tabs>

        </Col>
        <Col md={5}>
          {getAffiliateSettings()}
          <DisplayBox headerText="Estimated Monthly Revenue" headerIcon="fas fa-money-bill">
            <div><b>Revenue: {formatter.format(revenue.monthlyRevenue)}</b></div>
            <div>Commissions: -{formatter.format(revenue.commissions)}</div>
            <h4>Net Revenue: {formatter.format(revenue.netRevenue)}</h4>
          </DisplayBox>
          <AffiliateSummary />
          <AdminTickets />
        </Col>
      </Row>

    </>
  );
};